var _circle, _circle2, _circle3, _g, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComplaintsCenterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#1552E8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.9989,
    cy: 44.9989,
    r: 42.4286,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1547_127556",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 80,
    height: 80
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.0203,
    cy: 45.0203,
    r: 39.8796,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1547_127556)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.392 38.7383L48.6529 43.4339C46.5659 44.9992 43.4355 44.9992 41.3485 43.4339L35.6094 38.7383",
    stroke: "#FF8165",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 62H35C29 62 25 59 25 52V38C25 31 29 28 35 28H55C61 28 65 31 65 38V44",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 39L48.74 44C46.68 45.64 43.3 45.64 41.24 44L35 39",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4181 50.5406L52.3381 57.6206C52.0581 57.9006 51.7981 58.4206 51.7381 58.8006L51.3581 61.5006C51.2181 62.4806 51.8981 63.1606 52.8781 63.0206L55.5781 62.6406C55.9581 62.5806 56.4981 62.3205 56.7581 62.0405L63.8381 54.9606C65.0581 53.7406 65.6381 52.3206 63.8381 50.5206C62.0581 48.7406 60.6381 49.3206 59.4181 50.5406Z",
    stroke: "#A020FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3984 51.5605C58.9984 53.7205 60.6784 55.4005 62.8384 56.0005",
    stroke: "#A020FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaintsCenterLogo);
export default __webpack_public_path__ + "static/media/ComplaintsCenterLogo.a17bf355d0d446b00e7759d1c4db0bbf.svg";
export { ForwardRef as ReactComponent };